module.exports = __webpack_public_path__ + "static/img/bnr_C-YM_official.5136dfd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/domain3/bnr_C-YM_official.png
// module id = I0y9
// module chunks = 0